module.exports = __webpack_public_path__ + "static/corona-1508ab4847a5827ba9d6ce6d60bc1cac.jpg";